// extracted by mini-css-extract-plugin
export default {"categories":"Tables_categories__KgFcT","tablerow":"Tables_tablerow__iNAj2","redtext":"Tables_redtext__AIJFV","greentext":"Tables_greentext__TFCeO"};